import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { ChangeOrganizationFolderDialogConfiguration } from './change-organization-folder-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class ChangeOrganizationModalService extends BaseModalService<ChangeOrganizationFolderDialogConfiguration> {}
